import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ colors, font, spacing, border }) => ({
  wrapper: {
    gap: spacing(3),
  },
  card: {
    borderRadius: border.radius.md,
    overflow: "hidden",
  },
  imageContainer: {
    // No borderRadius: `card` already clips to the same radius over the same
    // box, and a rounded mask costs an offscreen GPU pass per card. Keeping
    // `overflow: hidden` at radius 0 is a plain rect clip, which is free.
    overflow: "hidden",
    flex: 1,
    backgroundColor: colors.backgroundSurface,
  },
  image: {
    ...StyleSheet.absoluteFill,
    _web: {
      transition: "transform 0.2s ease-in-out",
      _hover: {
        transform: "scale(1.02)",
      },
    },
  },
  imageDimensions: {
    width: spacing(42),
    height: spacing(42),
  },
  metaContainer: {
    height: spacing(12),
  },
  meta: {
    position: "absolute",
    left: 0,
    right: 0,
    paddingHorizontal: spacing(1),
    gap: spacing(1),
  },
  subtitle: {
    opacity: 0.8,
    width: "100%",
    maxWidth: "95%",
    _web: {
      minHeight: font.lineHeights.sub,
    },
  },
  duration: {
    position: "absolute",
    bottom: spacing(2),
    right: spacing(2),
    backgroundColor: colors.backgroundBrand,
    paddingVertical: spacing(1),
    paddingHorizontal: spacing(2),
    borderRadius: border.radius.xs,
  },
  progressBar: {
    position: "absolute",
    bottom: spacing(4),
    left: spacing(2),
    right: spacing(2),
    backgroundColor: colors.backgroundScrim,
    borderRadius: border.radius.xs,
    height: spacing(1),
  },
  progressAmount: {
    backgroundColor: colors.foregroundDefault,
    borderRadius: border.radius.xs,
    height: "100%",
  },
}));

export default stylesheet;
